<template>
    <div>
        <app-finalizacao
            :finalizacao="finalizacao"
            :finalizacoesServicos="obterFinalizacoesServicos()"
            v-show="mostrarFinalizacao"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
        >
            <template slot="entregasBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="success"
                        @click="carregarAssociarEntregas()"
                        v-if="mostrarBtnAssociarEntregas"
                        >Associar Entregas</b-button
                    >
                </b-button-group>
            </template>
            <template slot="entregaAcoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharEntrega(data.entregaId)"
                    ></i>
                </span>
            </template>
            <template slot="despViagensBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="success"
                        @click="carregarAssociarDespViagens()"
                        v-if="mostrarBtnAssociarDespViagens"
                        >Associar Despesas de Viagens</b-button
                    >
                </b-button-group>
            </template>
        </app-finalizacao>
        <router-view
            v-if="finalizacao"
            :finalizacao="finalizacao"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
        ></router-view>
    </div>
</template>

<script>
import FinalizacoesServicos from './FinalizacoesServicos'
import Finalizacao from '@/app/credenciados/componentes/finalizacoes/Finalizacao'

export default {
    data() {
        return {
            finalizacao: {}
        }
    },

    methods: {
        obterFinalizacao() {
            this.$store.dispatch('addRequest')
            FinalizacoesServicos.obterPorId(
                this.$route.params.finalizacaoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacao = response.data
                    } else {
                        this.$toast.error(
                            'Não foi possível obter a finalização.',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFinalizacoesServicos() {
            return FinalizacoesServicos
        },

        detalharEntrega(entregaId) {
            this.$router.push({
                name: 'Credenciados_Finalizacoes_Entrega',
                params: {
                    entregaId: entregaId
                }
            })
        },

        obterFinalizacaoAtualizada() {
            this.obterFinalizacao()
            this.$store.dispatch('setRecarregar', true)
        },

        carregarAssociarEntregas() {
            this.$router.push({
                name: 'Credenciados_Finalizacoes_AssociarEntregas'
            })
        },

        carregarAssociarDespViagens() {
            this.$router.push({
                name: 'Credenciados_Finalizacoes_AssociarDespViagens'
            })
        }
    },

    computed: {
        mostrarBtnAssociarEntregas() {
            return (
                (this.finalizacao.status === 0 ||
                    this.finalizacao.status === 5) &&
                this.$temAcesso('CRED-FORN-FIN-03')
            )
        },

        mostrarBtnAssociarDespViagens() {
            return (
                (this.finalizacao.status === 0 ||
                    this.finalizacao.status === 5) &&
                this.$temAcesso('CRED-FORN-FIN-03')
            )
        },

        mostrarFinalizacao() {
            return this.$route.name === 'Credenciados_Finalizacoes_Detalhar'
        }
    },

    components: {
        AppFinalizacao: Finalizacao
    },

    created() {
        this.obterFinalizacao()
    }
}
</script>
